<template>
  <div class="frame-sequence w-100p h-100p">
    <img :src="currImgSrc" width="100%" height="100%" alt="" />
  </div>
</template>

<script>
  import { gsap } from 'gsap'
  import { ScrollTrigger } from 'gsap/dist/ScrollTrigger.js'
  export default {
    props: {
      imgList: {
        required: true,
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        currImgSrc: this.imgList[0]
      }
    },
    mounted() {
      ScrollTrigger.create({
        trigger: '.frame-sequence',
        start: 'top-=1000 top',
        end: 'top-=1000',
        // markers: true,
        onEnter: () => {
          this.loadImages()
        }
      })
      let progress
      ScrollTrigger.create({
        trigger: '.frame-sequence',
        start: 'top top',
        end: 'bottom+=500',
        // markers: true,
        scrub: 1,
        onUpdate: (self) => {
          if (self.progress > 0.99) return
          progress = self.progress.toFixed(2).slice(2)
          if (progress < 10) {
            progress = progress.slice(1)
          }
          // console.log(progress)
          this.currImgSrc = this.imgList[progress]
        }
      })
    },
    methods: {
      loadImages(fn) {
        let count = 0
        let imgObj = null
        this.imgList.forEach((value) => {
          imgObj = new Image()
          imgObj.onload = () => {
            count++
            if (count === this.imgList.length) {
              fn && fn()
            }
          }
          imgObj.onerror = () => {
            count++
          }
          imgObj.src = value
        })
      },
      framesequence() {
        let progress
        gsap.timeline({
          scrollTrigger: {
            trigger: '.frame-sequence',
            start: 'top top',
            end: 'bottom bottom',
            // markers: true,
            scrub: 1,
            onUpdate: (self) => {
              if (self.progress >= 0.9) return
              progress = self.progress.toFixed(2).slice(2)
              if (progress < 10) {
                progress = progress.slice(1)
              }

              this.currImgSrc = this.imgList[progress]
            }
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped></style>
